import styled, { css } from "styled-components";
import { StyledGridContainerProps } from "./types";

export const TextWrap = styled.div`
  text-align: center;
`;

const FontStyles = css`
  font-size: ${({ theme }) => theme.fontSizes[5]};
`;

export const DreamTeamHeading = styled.h3`
  ${FontStyles}
  padding: ${({ theme }) => theme.space[3]} ${({ theme }) => theme.space[3]} 0;
  margin: 0;
`;

export const PitchWrapper = styled.div`
  padding-top: ${({ theme }) => theme.space[4]};
  border-radius: ${({ theme }) => theme.radii[3]};
  border: ${({ theme }) => theme.borders[3]};
  background-color: ${({ theme }) => theme.colors.white4};
`;

export const PitchHeading = styled.h4`
  ${FontStyles}
  margin: 0;
  margin-inline-start: ${({ theme }) => theme.space[4]};
  color: ${({ theme }) => theme.colors.white};

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    margin-inline-start: ${({ theme }) => theme.space[3]};
    margin-block-end: ${({ theme }) => theme.space[3]};
  }
`;

export const ButtonLinkWrapper = styled.div`
  width: 100%;
  align-self: center;
  margin: auto;

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    width: 40%;
  }
`;

export const TableWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space[4]};
  min-width: 0;
  padding: 0 ${({ theme }) => theme.space[1]};
  border: ${({ theme }) => theme.borders[3]};
  border-radius: ${({ theme }) => theme.radii[1]};
`;

export const TransfersWrap = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.space[4]};

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    grid-template-columns: 1fr 1fr;
  }
`;

/* GRID LAYOUT COMPONENTS */

export const GridWrapper = styled.div`
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 1fr;
  grid-gap: ${({ theme }) => theme.space[4]};
  max-width: 1220px;
  min-height: 0;
  min-width: 0;
  margin: ${({ theme }) => `${theme.space[4]} auto`};
  padding: 0 ${({ theme }) => theme.space[2]};

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    grid-template-columns: 1fr 1fr 1fr;
    /* Last row (auto) is flexible so FixturesGridContainer can grow
     * without inflating the rows above it. */
    grid-template-rows: repeat(5, min-content) auto;
  }
`;

export const PointsScoreboardGridContainer = styled.div`
  min-width: 0;

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    grid-column: 1/3;
    grid-row: 1;
  }
`;

export const CountdownGridContainer = styled.div`
  min-width: 0;

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    grid-column: 3;
    grid-row: 1;
  }
`;

export const PitchGridContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space[4]};
  min-width: 0;

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    grid-column: 1 / 3;
    grid-row: 2;
  }
`;

export const FixturesGridContainer = styled.div<StyledGridContainerProps>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space[4]};
  min-width: 0;

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    grid-column: 3;
    /* -1 always resolves to the last row in GridWrapper's
     * grid-template-rows, so this keeps spanning correctly however
     * many fixture rows are rendered. */
    grid-row: ${({ $canShowCountdown }) =>
      $canShowCountdown ? "2 / -1" : "1 / -1"};
  }
`;

export const EventInfoGridContainer = styled.div`
  min-width: 0;

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    grid-column: 1 / 3;
  }
`;

export const TransfersGridContainer = styled.div`
  min-width: 0;

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    grid-column: 1 / 3;
  }
`;

export const DreamTeamGridContainer = styled.div`
  min-width: 0;

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    grid-column: 1 / 3;
  }
`;
